import { useState } from 'react';
import { Slider } from '@pasqal/core/ui/components/pulser-studio/components/Slider';
import NumberInput from '~/components/widgets/NumberInput/NumberInput';
import EditorLabel from '../EditorLabel/EditorLabel';
import './EditorSlider.css';

interface EditorSliderProps {
  name: string;
  value: number;
  onChange: (val: number) => void;
  label: string;
  max: number;
  min: number;
  step?: number;
  divisions?: number[];
  snapRange?: number;
  logarithmic?: boolean;
  unit?: string;
  disabled?: boolean;
  onBlur?: () => void;
}

export default function EditorSlider({
  name,
  value,
  onChange,
  label,
  max,
  min,
  step,
  divisions,
  snapRange,
  logarithmic,
  unit,
  disabled,
  onBlur
}: EditorSliderProps) {
  // Tracks the in-progress drag value so the input updates on every drag tick
  // without waiting for the parent re-render cycle.
  // null when not dragging — falls back to the controlled `value` prop.
  const [dragValue, setDragValue] = useState<number | null>(null);

  return (
    <div className="EditorSlider">
      <div className="EditorSlider-header">
        <EditorLabel label={label} htmlFor={name} flex />
        <NumberInput
          className="EditorSlider-input"
          name={name}
          value={dragValue ?? value}
          max={max}
          min={min}
          step={step}
          unit={unit}
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
        />
      </div>
      <Slider
        value={value}
        max={max}
        min={min}
        step={step}
        divisions={divisions}
        snapRange={snapRange}
        logarithmic={logarithmic}
        disabled={disabled}
        onBlur={() => {
          setDragValue(null);
          onBlur?.();
        }}
        onChange={onChange}
        onChangeImmediate={setDragValue}
      />
    </div>
  );
}
